import { IOpenAiSavedDescriptions } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { IAction, IStateStrict } from '@/shared/interfaces/store-base';
import {
  IApiResponse,
  IMetaResponse,
} from '@/shared';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

interface IOpenAISavedDescriptionState {
  list: IApiResponse<IOpenAiSavedDescriptions[], IMetaResponse> | undefined,
  activePropertyAiDescription: IOpenAiSavedDescriptions,
  activeLocationAiDescription: IOpenAiSavedDescriptions,
  activeUnitAiDescription: IOpenAiSavedDescriptions,
}

// Base store configuration
const adminGatewayResourcePath: string = '/client-api/open_ai_saved_descriptions';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {};
const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IOpenAiSavedDescriptions>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
    list: undefined,
    activePropertyAiDescription: {} as IOpenAiSavedDescriptions,
    activeLocationAiDescription: {} as IOpenAiSavedDescriptions,
    activeUnitAiDescription: {} as IOpenAiSavedDescriptions,
  } as IOpenAISavedDescriptionState,

  getters: {
    ...base.getters,
    activePropertyAiDescription: (state: IOpenAISavedDescriptionState) => state.list?.data?.filter((description: IOpenAiSavedDescriptions) => description.status === 'active' && description.tableColumn === 'building_overview')[0],
    activeLocationAiDescription: (state: IOpenAISavedDescriptionState) => state.list?.data?.filter((description: IOpenAiSavedDescriptions) => description.status === 'active' && description.tableColumn === 'location_details')[0],
    activeUnitAiDescription: (state: IOpenAISavedDescriptionState) => state.list?.data?.filter((description: IOpenAiSavedDescriptions) => description.status === 'active' && description.tableColumn === 'description')[0],
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
    createOpenAiDescription: async (_ctx: IAction<IStateStrict<IOpenAiSavedDescriptions>>, payload: {logId: number, data: IOpenAiSavedDescriptions}) => {
      const response = await adminRequest.post(`${adminGatewayResourcePath}?logId=${payload.logId}`, payload.data);
      return response.data;
    },
  },
};
